import { Box, SxProps } from "@mui/material"
import { ReactNode } from "react"
import RoadmapTierComplete from 'assets/images/RoadmapTierComplete.png'
import { mediaQueryValues } from "Utils/MediaQueries";
import { useMediaQueries } from "Hooks/useMediaQueries";
import zIndex from "@mui/material/styles/zIndex";

const Background = () => (
  <Box sx={{position: 'absolute', left: '0px', top:'0px', width: '100%', height: '100%', zIndex: -100}}>
    <img src={RoadmapTierComplete} style={{width: '100%', height: '100%'}}/>
  </Box>
)


const Modal = ({children, sx }:{children?: ReactNode, sx?: SxProps}) => {
  const {maxHeight,maxWidth} = useMediaQueries()
  console.log("Modal maxHeight, maxWidth:", maxHeight, maxWidth)
  const modalStyles = {
    position: 'absolute',
    width: '60%',
    minHeight:  window.innerWidth < 1200 ? '500px' : '600px',
    height: '60%',
    top: maxHeight == mediaQueryValues.minHeight750 ? '45%': '50%',
    left: '50%',
    transform: 'translate(-50%, -45%)',
    background: 'linear-gradient(229.67deg, #1D2F44 -6.17%, #071423 89.04%)',
    borderRadius: '8px',
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'center', 
    justifyItems: 'center',
    minWidth: window.innerWidth < 1200 ? '900px' : '1200px',
    maxWidth: '1300px',
    zIndex: 2000
  }
  return (
    <Box
      sx={Object.assign(modalStyles, sx)}
    >
      <Background/>
      {children}
    </Box>
  )
}
export default Modal